import React, { createContext, useContext, useEffect, useState } from 'react';
import c from './firestore-write-permission-provider.module.scss';
import { fsDocListener, fsUpdateDoc } from '../../firebase/firestore';
import { AuthContext } from '../../auth/AuthContext';
import { arrayRemove, arrayUnion } from 'firebase/firestore';

export const FirestoreWritePermissionContext = createContext();

const FirestoreWritePermissionProvider = ({ children }) => {
  const PERMS_DOC_PATH = 'testUtils/permissions';
  const [checkWritePerms, setCheckWritePerms] = useState(false);
  const [usersWithWritePerms, setUsersWithWritePerms] = useState([]);
  const { user } = useContext(AuthContext);
  const uid = user.uid;
  const hasWritePerms = usersWithWritePerms?.includes(uid);

  const updateWritePerms = async (hasPerms) => {
    if (!uid) {
      console.error('No UID found');
      return;
    }

    const handleError = (error) => {
      console.error('Could not update firestore write perms', error);
    };

    if (hasPerms) {
      fsUpdateDoc(PERMS_DOC_PATH, {
        usersWithWritePerms: arrayUnion(uid),
      }).catch(handleError);
    }

    if (!hasPerms) {
      fsUpdateDoc(PERMS_DOC_PATH, {
        usersWithWritePerms: arrayRemove(uid),
      }).catch(handleError);
    }
  };

  useEffect(() => {
    const unsub = fsDocListener(PERMS_DOC_PATH, (snap) => {
      const permissionsData = snap.data();
      setCheckWritePerms(permissionsData?.checkWritePerms);
      setUsersWithWritePerms(permissionsData?.usersWithWritePerms);
    });

    return () => {
      unsub();
    };
  }, []);

  return (
    <FirestoreWritePermissionContext.Provider
      value={{
        checkWritePerms,
        hasWritePerms,
        updateWritePerms,
      }}
    >
      {children}
      {checkWritePerms && hasWritePerms && (
        <div className={c.warningOverlay} inert="">
          FIRESTORE WRITES ENABLED WHILE IMPERSONATING
        </div>
      )}
    </FirestoreWritePermissionContext.Provider>
  );
};

export default FirestoreWritePermissionProvider;
